/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractService} from './abstract.service';
import {Country} from '../_models/models';

@Injectable()
export class CountryService extends AbstractService<Country> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
    super(locale, httpClient, 'country', 'countries');
  }

}
